import { PropertyTypes } from "@ext/properties/models";
import type { ComponentType } from "react";
import { DatePropertyValue } from "./DatePropertyValue";
import { EnumPropertyValue } from "./EnumPropertyValue";
import { FlagPropertyValue } from "./FlagPropertyValue";
import { ManyPropertyValue } from "./ManyPropertyValue";
import { NumericPropertyValue } from "./NumericPropertyValue";
import { TextPropertyValue } from "./TextPropertyValue";
import type { PropertyValueProps } from "./types";

const propertyValueComponents: Partial<Record<PropertyTypes, ComponentType<PropertyValueProps>>> = {
	[PropertyTypes.date]: DatePropertyValue,
	[PropertyTypes.enum]: EnumPropertyValue,
	[PropertyTypes.flag]: FlagPropertyValue,
	[PropertyTypes.many]: ManyPropertyValue,
	[PropertyTypes.numeric]: NumericPropertyValue,
	[PropertyTypes.text]: TextPropertyValue,
};

export const getPropertyValueComponent = (type: PropertyTypes) => propertyValueComponents[type] ?? null;

export const PropertyValue = (props: PropertyValueProps) => {
	const ValueComponent = getPropertyValueComponent(props.property.type);
	return ValueComponent ? <ValueComponent {...props} /> : null;
};
